import login from './login.png'
import logged from './logged.png'

export default [login, logged]
